import { useTranslation } from 'react-i18next';
import { TransactionIcon } from '../../icons';
import { NotYetListItem } from './NotYetListItem';

export function NoTransactionsListItem() {
  const { t } = useTranslation();
  return <NotYetListItem icon={<TransactionIcon />} title={t('No transactions yet')} />;
}
